<script>
import { mapGetters } from "vuex";
import { LocalNotifications } from '@capacitor/local-notifications';

export default {
  data() {
    return {
      intervalId: 0
    }
  },
  props: {
    MsgType: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(['baseUrl', 'appToken', "auth"])
  },
  mounted() {
    console.log("MsgType received:", this.MsgType)
  },
  created() {
  },

  methods: {
    play_sound(src) {
      const sound = new Audio(src);
      sound.play().catch((error) => {
        console.error('Error playing sound:', error);
      });
    },
    getdatafromsocket(msg_type) {
      console.log(msg_type);
      if (msg_type == 'new_message') {
        this.play_sound('/app/alrams/message.mp3');
        this.scheduleNotificationMessage();
      } else if (msg_type == 'new_service') {
        this.play_sound('/app/alrams/service.mp3');
        this.scheduleNotification();
      } else if (msg_type == 'cancel_service') {
        this.play_sound('/app/alrams/cancel.mp3');
        this.scheduleNotificationCancel();
        this.$router.push({ path: '/' });
      } else if (msg_type == 'new_free_service') {
        this.play_sound('/app/alrams/free.mp3');
        this.scheduleNotificationFree();
      } else if (msg_type === 'customer_changed_payement_method') {
        this.play_sound('/app/alrams/pay.mp3');
      }
      
    },
    async scheduleNotification() {
      // درخواست مجوز برای ارسال نوتیفیکیشن
      const permission = await LocalNotifications.requestPermissions();

      if (permission.display === 'granted') {
        // تنظیم یک نوتیفیکیشن محلی
        await LocalNotifications.schedule({
          notifications: [
            {
              id: 1,
              title: 'سرویس جدید',
              body: 'سرویس جدید ارسال شد بررسی نمایید',
              schedule: { at: new Date(Date.now() + 1000 * 2) }, // نوتیفیکیشن پس از 2 ثانیه ارسال شود
              sound: null,
              attachments: null,
              actionTypeId: '',
              extra: null,
            },
          ],
        });
      } else {
        console.log('دسترسی به ارسال نوتیفیکیشن محلی داده نشد.');
      }
    },

    async scheduleNotificationFree() {
      // درخواست مجوز برای ارسال نوتیفیکیشن
      const permission = await LocalNotifications.requestPermissions();

      if (permission.display === 'granted') {
        // تنظیم یک نوتیفیکیشن محلی
        await LocalNotifications.schedule({
          notifications: [
            {
              id: 1,
              title: 'سرویس آزاد جدید',
              body: 'سرویس آزاد جدید ارسال شد بررسی نمایید',
              schedule: { at: new Date(Date.now() + 1000 * 2) }, // نوتیفیکیشن پس از 2 ثانیه ارسال شود
              sound: null,
              attachments: null,
              actionTypeId: '',
              extra: null,
            },
          ],
        });
      } else {
        console.log('دسترسی به ارسال نوتیفیکیشن محلی داده نشد.');
      }
    },


    async scheduleNotificationCancel() {
      // درخواست مجوز برای ارسال نوتیفیکیشن
      const permission = await LocalNotifications.requestPermissions();

      if (permission.display === 'granted') {
        // تنظیم یک نوتیفیکیشن محلی
        await LocalNotifications.schedule({
          notifications: [
            {
              id: 1,
              title: 'سرویس شما لغو گردید',
              body: 'سرویس شما لغو گردید',
              schedule: { at: new Date(Date.now() + 1000 * 2) },
              sound: null,
              attachments: null,
              actionTypeId: '',
              extra: null,
            },
          ],
        });
      } else {
        console.log('دسترسی به ارسال نوتیفیکیشن محلی داده نشد.');
      }
    },

    async scheduleNotificationMessage() {
      // درخواست مجوز برای ارسال نوتیفیکیشن
      const permission = await LocalNotifications.requestPermissions();

      if (permission.display === 'granted') {
        // تنظیم یک نوتیفیکیشن محلی
        await LocalNotifications.schedule({
          notifications: [
            {
              id: 1,
              title: 'پیام جدید',
              body: 'پیام جدید ارسال شد بررسی نمایید',
              schedule: { at: new Date(Date.now() + 1000 * 2) }, // نوتیفیکیشن پس از 2 ثانیه ارسال شود
              sound: null,
              attachments: null,
              actionTypeId: '',
              extra: null,
            },
          ],
        });
      } else {
        console.log('دسترسی به ارسال نوتیفیکیشن محلی داده نشد.');
      }
    },
  },
  watch: {
    
  },
}
</script>

<style scoped>
button {
  margin: 10px;
}
</style>